/*
 * @Author: Teemo Ding
 * @Date: 2021-09-15 08:49:16
 * @LastEditTime: 2022-06-10 14:23:01
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelDomain/List/MissingPageRedirection/index.tsx
 */
import { Button, Form } from '@/src/components/Antd';
import EditableTable from '@/src/components/EditableTable/EditableTable';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import LinkLibraryWithSisterScScope from 'src/constrains/LinkLibrary/LinkLibraryWithSisterScScope';

import {
  MissingPageRedirectType,
  MissingPageType,
} from '@/src/types/common/domain';
import { LinkModuleType } from '@/src/types/common/linkType';
import React, { Fragment } from 'react';
import { useParams } from 'react-router';
import ModalHoc from 'src/constrains/ModalHOC';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { redirectColumns } from '../config';
import css from '../css.module.less';

const { List } = Form;
interface EditableTableProps {
  value?: any;
  fields: any;
  modalOp?: any;
  form: any;
  edit: boolean;
  setEdit: any;
}

const EditableTableInForm = ModalHoc(
  ({ form, fields, edit, modalOp, setEdit }: EditableTableProps) => {
    const i18n = useI18n();
    const getI18n = (str) => i18nGet(i18n, str);
    const { setShowModal, setModalTitle, setModalContent } = modalOp || {};
    const params: any = useParams();

    const { uuid: salesChannelUuid } = params;
    const handleMissingPageOnCahnge = (selectValue, dataValue, index) => {
      setShowModal(true);
      setModalTitle('Link');
      const renderModalContent = () => {
        const currentLinkModule =
          form.getFieldValue(['missingPageRedirections', index]).linkModule ||
          {};

        setModalContent(
          <>
            <LinkLibraryWithSisterScScope
              mode={'no-modal'}
              noModalHeader={<div>{'Link'}</div>}
              hideTitle
              containerClassName={css.linkLibrary}
              salesChannelUuid={salesChannelUuid}
              presetLinkTypeFilter={
                dataValue.missingPageType ==
                MissingPageType.NoAvailableContentVersion
                  ? [LinkModuleType.LinkLibrary]
                  : [
                      LinkModuleType.HomePage,
                      LinkModuleType.AllProducts,
                      LinkModuleType.LinkLibrary,
                    ]
              }
              data={currentLinkModule}
              onChange={(value) => {
                form.setFields([
                  {
                    name: ['missingPageRedirections', index],
                    value: {
                      ...form.getFieldValue(['missingPageRedirections', index]),
                      linkModule: value,
                    },
                  },
                ]);
                renderModalContent();
              }}
            />
            <div className={css.footer}>
              <Button
                className={css.button}
                onClick={() => setShowModal(false)}>
                {getI18n('general.commonHeader.discard_text')}
              </Button>
              <Button
                className={css.button}
                type='primary'
                onClick={() => {
                  const updatedDataValue = form.getFieldValue([
                    'missingPageRedirections',
                    index,
                  ]);
                  form.setFields([
                    {
                      name: ['missingPageRedirections', index],
                      value: {
                        ...updatedDataValue,
                        missingPageRedirectType:
                          MissingPageRedirectType.OtherPage,
                      },
                    },
                  ]);
                  setEdit(true);
                  setShowModal(false);
                }}>
                {getI18n('general.linkModule.Modal.add')}
              </Button>
            </div>
          </>,
        );
      };
      renderModalContent();
    };

    return (
      <Fragment>
        <EditableTable
          id='missingPageRedirections'
          dataSource={fields}
          columns={redirectColumns(
            fields,
            handleMissingPageOnCahnge,
            edit,
            form,
            getI18n,
            // linkListData,
          )}
          rowKey={(record) => record.missingPageType}
          pagination={false}
        />
      </Fragment>
    );
  },
);

const MissingPageRedirection = ({
  form,
  hasModified,
  setHasModified,
  disabled,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const handleCancel = () => {
    setHasModified(false);
    form.resetFields();
  };

  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.containerClassName}
      title={getI18n(
        'salesChannelDomainAndStatus.list.missingPageRedirection',
      )}>
      <List name='missingPageRedirections'>
        {(fields) => {
          return (
            <EditableTableInForm
              edit={hasModified}
              setEdit={setHasModified}
              fields={fields}
              form={form}
            />
          );
        }}
      </List>
      <div className={css.buttonCombin}>
        {!hasModified && (
          <Button
            disabled={disabled}
            type='primary'
            onClick={() => setHasModified(true)}>
            {getI18n('general.edit')}
          </Button>
        )}
        {hasModified && (
          <Button
            disabled={disabled}
            type='primary'
            onClick={() => form.submit()}>
            {getI18n('general.confirm')}
          </Button>
        )}
        {hasModified && (
          <Button className={css.last} onClick={handleCancel}>
            {getI18n('general.cancel')}
          </Button>
        )}
      </div>
    </SectionWrapper>
  );
};
export default MissingPageRedirection;
